/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Illegal_Main_Deck_No_DecklistInputs */



/**
* | output |
* | --- |
* | "Illegal Main Deck (No Decklist)" |
*
* @param {Sanction_Sub_Illegal_Main_Deck_No_DecklistInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_illegal_main_deck_no_decklist = /** @type {((inputs?: Sanction_Sub_Illegal_Main_Deck_No_DecklistInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Illegal_Main_Deck_No_DecklistInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deck Principal Illégal (Pas de Decklist)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deck Principal Ilegal (Sin Lista)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Deck Principal Ilegal (Sem Lista)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Deck Principale Illegale (Nessuna Decklist)")
	return /** @type {LocalizedString} */ ("Illegal Main Deck (No Decklist)")
});